import React, { useEffect, useState, useMemo, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateProfileInStore } from "../../redux/userSlice";
import {
  Check,
  ChevronDown,
  ChevronUp,
  ArrowLeft,
  Loader2,
} from "lucide-react";
import "./DogDetailsEditPage.css";
import progressIcon from "../../assets/progressIcon3.png";
import nextIcon from "../../assets/nextButtonIcon.png";
import nextIcon2 from "../../assets/nextButtonIcon2.png";
import { WheelPicker, WheelPickerWrapper } from "../../components/wheel-picker";
import apiClient from "../../api/apiClient";
import appIcon from "../../assets/appIcon.svg";
import socialPawsLogo from "../../assets/socialPawsLogo.svg";
import MobileTopBar from "../../components/MobileTopBar";
import MobileBottomBar from "../../components/MobileBottomBar";
import DesktopTopBar from "../../components/DesktopTopBar";

// Hardcoded Breed List
const BREED_LIST = [
  "Affenpinscher",
  "Afghan Hound",
  "Airedale Terrier",
  "Akita",
  "Alaskan Malamute",
  "American Bulldog",
  "American Eskimo Dog",
  "American Foxhound",
  "American Pit Bull Terrier",
  "American Staffordshire Terrier",
  "Australian Cattle Dog",
  "Australian Shepherd",
  "Australian Terrier",
  "Aussiedoodle",
  "Basenji",
  "Basset Hound",
  "Beagle",
  "Bearded Collie",
  "Bedlington Terrier",
  "Belgian Malinois",
  "Belgian Sheepdog",
  "Belgian Tervuren",
  "Bernedoodle",
  "Mini Bernedoodle",
  "Bernese Mountain Dog",
  "Bichon Frise",
  "Black and Tan Coonhound",
  "Bloodhound",
  "Border Collie",
  "Border Terrier",
  "Borzoi",
  "Boston Terrier",
  "Bouvier des Flandres",
  "Boxer",
  "Boykin Spaniel",
  "Briard",
  "Brittany",
  "Brussels Griffon",
  "Bull Terrier",
  "Bulldog (English)",
  "Bullmastiff",
  "Cairn Terrier",
  "Canaan Dog",
  "Cane Corso",
  "Cardigan Welsh Corgi",
  "Cavalier King Charles Spaniel",
  "Cavapoo",
  "Chesapeake Bay Retriever",
  "Chiweenie",
  "Chihuahua",
  "Chinese Crested",
  "Chow Chow",
  "Clumber Spaniel",
  "Cockapoo",
  "Cocker Spaniel",
  "Collie",
  "Coton de Tulear",
  "Curly-Coated Retriever",
  "Dachshund",
  "Mini Dachshund",
  "Long-Haired Dachshund",
  "Wire-Haired Dachshund",
  "Dalmatian",
  "Dandie Dinmont Terrier",
  "Doberman Pinscher",
  "Dogo Argentino",
  "Dutch Shepherd",
  "English Setter",
  "English Springer Spaniel",
  "English Toy Spaniel",
  "Field Spaniel",
  "Finnish Spitz",
  "Flat-Coated Retriever",
  "French Bulldog",
  "German Pinscher",
  "German Shepherd",
  "German Shorthaired Pointer",
  "German Wirehaired Pointer",
  "Giant Schnauzer",
  "Glen of Imaal Terrier",
  "Golden Retriever",
  "Goldendoodle",
  "Mini Goldendoodle",
  "Gordon Setter",
  "Great Dane",
  "Great Pyrenees",
  "Greater Swiss Mountain Dog",
  "Greyhound",
  "Havanese",
  "Ibizan Hound",
  "Icelandic Sheepdog",
  "Irish Setter",
  "Irish Terrier",
  "Irish Water Spaniel",
  "Irish Wolfhound",
  "Italian Greyhound",
  "Jack Russell Terrier",
  "Japanese Chin",
  "Keeshond",
  "Kerry Blue Terrier",
  "Komondor",
  "Kuvasz",
  "Labrador Retriever",
  "Labradoodle",
  "Mini Labradoodle",
  "Lagotto Romagnolo",
  "Lakeland Terrier",
  "Leonberger",
  "Lhasa Apso",
  "Lowchen",
  "Maltese",
  "Maltipoo",
  "Manchester Terrier",
  "Mastiff",
  "Mini American Shepherd (Mini Aussie)",
  "Miniature Bull Terrier",
  "Miniature Pinscher",
  "Miniature Schnauzer",
  "Mini Poodle",
  "Morkie",
  "Neapolitan Mastiff",
  "Newfoundland",
  "Norfolk Terrier",
  "Norwegian Elkhound",
  "Norwich Terrier",
  "Old English Sheepdog",
  "Other",
  "Otterhound",
  "Papillon",
  "Parson Russell Terrier",
  "Pekingese",
  "Pembroke Welsh Corgi",
  "Petit Basset Griffon Vendéen",
  "Pharaoh Hound",
  "Plott Hound",
  "Pointer",
  "Pomsky",
  "Pomeranian",
  "Portuguese Water Dog",
  "Poodle (Standard)",
  "Poodle (Toy)",
  "Pug",
  "Puggle",
  "Puli",
  "Pyrenean Shepherd",
  "Rat Terrier",
  "Redbone Coonhound",
  "Rescue / Unknown",
  "Rhodesian Ridgeback",
  "Rottweiler",
  "Saint Bernard",
  "Saluki",
  "Samoyed",
  "Schipperke",
  "Schnoodle",
  "Scottish Deerhound",
  "Scottish Terrier",
  "Sealyham Terrier",
  "Shar-Pei",
  "Shetland Sheepdog",
  "Sheepadoodle",
  "Shiba Inu",
  "Shih Tzu",
  "Shorkie",
  "Siberian Husky",
  "Silky Terrier",
  "Skye Terrier",
  "Sloughi",
  "Smooth Fox Terrier",
  "Soft Coated Wheaten Terrier",
  "Spinone Italiano",
  "Staffordshire Bull Terrier",
  "Standard Schnauzer",
  "Sussex Spaniel",
  "Swedish Vallhund",
  "Tibetan Mastiff",
  "Tibetan Spaniel",
  "Tibetan Terrier",
  "Toy Fox Terrier",
  "Vizsla",
  "Weimaraner",
  "Welsh Springer Spaniel",
  "Welsh Terrier",
  "West Highland White Terrier",
  "Whippet",
  "Wire Fox Terrier",
  "Wirehaired Pointing Griffon",
  "Xoloitzcuintli",
  "Yorkipoo",
  "Yorkshire Terrier",
  "Mixed Breed",
];

const DogDetailsEditPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.user);

  // Mobile Step State (1 for Left Panel, 2 for Right Panel)
  const [mobileStep, setMobileStep] = useState(location.state?.step || 1);

  const [formData, setFormData] = useState({
    dogName: "",
    dogBreed: "",
    selectedBreed1: "",
    selectedBreed2: "",
    selectedBreed3: "",
    dogGender: "",
    dogBirthDate: "",
    dogAgeGroup: "",
  });
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const res = await apiClient.get(`/user/details/${profile?.id}`);
        if (res.data?.status && res.data.data) {
          const userData = res.data.data;
          setUser(userData);
          if (userData.dogs && userData.dogs.length > 0) {
            const dog = userData.dogs[0];
            const genderValue =
              dog.dog_gender?.toLowerCase() === "female" ? "girl" : "boy";

            const mixed = dog.dog_mixedBreed || [];

            setFormData({
              dogName: dog.dog_name || "",
              dogBreed: dog.dog_breed || "",
              selectedBreed1: mixed[0] || "",
              selectedBreed2: mixed[1] || "",
              selectedBreed3: mixed[2] || "",
              dogGender: genderValue,
              dogBirthDate: dog.dog_birthday || "",
              dogAgeGroup: dog.age_group || "",
            });

            if (dog.dog_birthday) {
              const d = new Date(dog.dog_birthday);
              setBYear(d.getFullYear());
              setBMonth(d.getMonth());
              setBDay(d.getDate());
              setActiveSection("birthday");
            } else if (dog.age_group) {
              setActiveSection("ageGroup");
            }
          }
        }
      } catch (err) {
        console.error("Error fetching user:", err);
      } finally {
        setLoading(false);
      }
    };
    if (profile?.id) fetchUserDetails();
  }, [profile?.id]);

  const [activeSection, setActiveSection] = useState(null);
  const [bYear, setBYear] = useState(new Date().getFullYear());
  const [bMonth, setBMonth] = useState(new Date().getMonth());
  const [bDay, setBDay] = useState(new Date().getDate());

  const lastWheelValues = useRef({ y: null, m: null, d: null });

  const [mainSearch, setMainSearch] = useState("");
  const [subSearches, setSubSearches] = useState({
    selectedBreed1: "",
    selectedBreed2: "",
    selectedBreed3: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const [openDropdown, setOpenDropdown] = useState(null);

  const [isMainBreedDropdownOpen, setIsMainBreedDropdownOpen] = useState(false);
  const isMixedBreed =
    formData.dogBreed === "Mixed Breed" || formData.dogBreed === "Mix";

  // Reset sub-breeds if not mixed
  useEffect(() => {
    if (formData.dogBreed && !isMixedBreed) {
      setFormData((prev) => ({
        ...prev,
        selectedBreed1: "",
        selectedBreed2: "",
        selectedBreed3: "",
      }));
      setSubSearches({
        selectedBreed1: "",
        selectedBreed2: "",
        selectedBreed3: "",
      });
    }
  }, [isMixedBreed]);

  // Click outside listener
  useEffect(() => {
    function handleClickOutside(e) {
      if (!e.target.closest(".eddp-dropdown-wrapper")) {
        setIsMainBreedDropdownOpen(false);
        setOpenDropdown(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredMainBreeds = useMemo(() => {
    return BREED_LIST.filter((b) =>
      b.toLowerCase().includes(mainSearch.toLowerCase()),
    );
  }, [mainSearch]);

  const getFilteredSubBreeds = (field) => {
    const searchTerm = subSearches[field];
    return BREED_LIST.filter(
      (b) =>
        b !== "Mixed Breed" &&
        b.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  };

  // Date Options
  const yearOptions = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear + 1;
    const endYear = currentYear - 25;
    const years = [];
    for (let y = startYear; y >= endYear; y--) {
      years.push({ label: y.toString(), value: y });
    }
    return years;
  }, []);

  const monthOptions = useMemo(() => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months.map((m, i) => ({ label: m, value: i }));
  }, []);

  const dayOptions = useMemo(() => {
    const daysInMonth = new Date(bYear, bMonth + 1, 0).getDate();
    return Array.from({ length: daysInMonth }, (_, i) => ({
      label: (i + 1).toString(),
      value: i + 1,
    }));
  }, [bYear, bMonth]);

  const updateBirthdayData = (y, m, d) => {
    const maxDays = new Date(y, m + 1, 0).getDate();
    const safeDay = Math.min(d, maxDays);
    const formattedDate = `${y}-${String(m + 1).padStart(2, "0")}-${String(safeDay).padStart(2, "0")}`;

    setFormData((prev) => ({
      ...prev,
      dogBirthDate: formattedDate,
      dogAgeGroup: "",
    }));
  };

  useEffect(() => {
    if (lastWheelValues.current.y === null) {
      lastWheelValues.current = { y: bYear, m: bMonth, d: bDay };
      return;
    }

    if (
      lastWheelValues.current.y !== bYear ||
      lastWheelValues.current.m !== bMonth ||
      lastWheelValues.current.d !== bDay
    ) {
      setActiveSection("birthday");
      updateBirthdayData(bYear, bMonth, bDay);
      lastWheelValues.current = { y: bYear, m: bMonth, d: bDay };
    }
  }, [bYear, bMonth, bDay]);

  const handleAgeGroupSelect = (label) => {
    setActiveSection("ageGroup");
    setFormData((prev) => ({
      ...prev,
      dogAgeGroup: label,
      dogBirthDate: "",
    }));
  };

  const handleMainBreedSelect = (breed) => {
    setFormData({ ...formData, dogBreed: breed });
    setMainSearch("");
    setIsMainBreedDropdownOpen(false);
  };

  const handleBreedSelect = (field, breed) => {
    setFormData({ ...formData, [field]: breed });
    setSubSearches((prev) => ({ ...prev, [field]: "" }));
    setOpenDropdown(null);
  };

  const selectedSubBreedsCount = [
    formData.selectedBreed1,
    formData.selectedBreed2,
    formData.selectedBreed3,
  ].filter(Boolean).length;

  const isMixedBreedValid =
    (formData.dogBreed !== "Mixed Breed" && formData.dogBreed !== "Mix") ||
    selectedSubBreedsCount >= 2;

  // Validation States
  const isStep1Valid = !!(
    formData.dogName?.trim() &&
    formData.dogBreed &&
    formData.dogGender &&
    isMixedBreedValid
  );

  const isStep2Valid = !!(
    (activeSection === "birthday" && formData.dogBirthDate) ||
    (activeSection === "ageGroup" && formData.dogAgeGroup)
  );

  const isNextEnabled = isStep1Valid && isStep2Valid;

  const ageText = useMemo(() => {
    const birthDate = new Date(bYear, bMonth, bDay);
    const now = new Date();
    if (birthDate > now) return "0 YEARS OLD";
    let years = now.getFullYear() - birthDate.getFullYear();
    let months = now.getMonth() - birthDate.getMonth();
    let days = now.getDate() - birthDate.getDate();
    if (days < 0) months -= 1;
    if (months < 0) {
      years -= 1;
      months += 12;
    }
    if (years <= 0) {
      const totalMonths = Math.max(0, months + (days >= 0 ? 0 : -1)) || 0;
      return `${totalMonths} MONTH${totalMonths === 1 ? "" : "S"} OLD`;
    }
    return `${years} YEAR${years === 1 ? "" : "S"} OLD`;
  }, [bYear, bMonth, bDay]);

  const handleNext = async () => {
    if (window.innerWidth >= 1024) {
      if (!isNextEnabled || isUpdating) return;
    } else {
      if (!isStep2Valid || isUpdating) return;
    }

    setIsUpdating(true);
    try {
      const dogId = user?.dogs?.[0]?.id;
      if (!dogId) {
        console.error("No dog ID found to update");
        return;
      }
      const mixedBreedsList = [
        formData.selectedBreed1,
        formData.selectedBreed2,
        formData.selectedBreed3,
      ].filter(Boolean);

      const apiPayload = {
        user_id: profile?.id,
        dog_name: formData.dogName,
        dog_gender: formData.dogGender === "girl" ? "Female" : "Male",
        dog_birthday: formData.dogBirthDate || null,
        dog_breed: formData.dogBreed,
        dog_mixedBreed: JSON.stringify(mixedBreedsList),
        age_group: formData.dogAgeGroup,
      };

      const response = await apiClient.put(
        `/dogs/update-dog-by-id/${dogId}`,
        apiPayload,
      );

      if (response.data?.status) {
        const detailsRes = await apiClient.get(`/user/details/${profile?.id}`);

        if (!detailsRes.data?.status || !detailsRes.data.data) {
          throw new Error("Failed to fetch updated user");
        }

        await dispatch(updateProfileInStore(detailsRes.data.data));

        navigate("/edit-dog-personality");
      } else {
        console.error("Update failed:", response.data?.message);
      }
    } catch (error) {
      console.error("Error updating dog details:", error);
    } finally {
      setIsUpdating(false);
    }
  };

  const inactiveStyle = {
    opacity: 0.3,
    filter: "grayscale(1)",
    transition: "all 0.3s ease",
    cursor: "pointer",
  };

  const activeStyle = {
    opacity: 1,
    filter: "grayscale(0)",
    transition: "all 0.3s ease",
  };

  const searchInputStyle = {
    border: "none",
    outline: "none",
    width: "100%",
    padding: "0",
    background: "transparent",
    fontSize: "inherit",
    fontFamily: "inherit",
    color: "inherit",
  };

  const renderGenderButtons = () => {
    return ["boy", "girl"].map((g) => {
      const isActive = formData.dogGender === g;
      return (
        <button
          key={g}
          className={`eddp-gender-btn ${isActive ? "active" : ""}`}
          onClick={() => setFormData({ ...formData, dogGender: g })}
        >
          <div className="eddp-btn-content">
            {isActive && <Check size={24} strokeWidth={3} color="white" />}
            <span
              className="eddp-btn-text"
              style={{ color: isActive ? "white" : "black" }}
            >
              GOOD {g === "girl" ? "GIRL" : "BOY"}
            </span>
          </div>
        </button>
      );
    });
  };

  if (loading) {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background:
            "linear-gradient(157.14deg, #96f2de 2.76%, #58b8a3 96.76%)",
          zIndex: 9999,
        }}
      >
        <Loader2 className="animate-spin" size={40} />
      </div>
    );
  }

  return (
    <div
      className={`eddp-container ${mobileStep === 1 ? "eddp-mobile-step-1" : "eddp-mobile-step-2"}`}
    >
      {/* LEFT PANEL (Mobile Step 1) */}
      <div
        className={`eddp-panel eddp-left-panel ${mobileStep === 1 ? "eddp-mobile-active" : "eddp-mobile-hidden"}`}
      >
        {/* Mobile Top Header (Hidden on Desktop) */}
        {/* <div className="eddp-mobile-header eddp-mobile-only">
          <button
            className="eddp-login-back-btn eddp-mobile-back-override"
            onClick={() => navigate("/select-edit-profile")}
          >
            <ArrowLeft size={22} color="#000" strokeWidth={3} />
            <span style={{ color: "#000" }}>Back</span>
          </button>
          <div className="eddp-header-logo" style={{ color: "#009fd9" }}>
            <img
              src={socialPawsLogo}
              alt="Social Paws"
              className="eddp-logo-img"
            />
            <span>Social Paws</span>
          </div>
        </div> */}
        <MobileTopBar
          onBack={() => navigate("/select-edit-profile")}
          backColor="#000"
          logoColor="#009fd9"
          blueLogo="true"
        />

        {/* Desktop Back Button */}
        {/* <button
          className="eddp-login-back-btn eddp-desktop-only"
          onClick={() => navigate("/select-edit-profile")}
        >
          <ArrowLeft size={24} color="#000" strokeWidth={3} />
          <span style={{ color: "#000" }}>Back</span>
        </button> */}
        <DesktopTopBar
          showBack={true}
          onBack={() => navigate("/select-edit-profile")}
          backColor="#000"
        />

        <div className="eddp-content-wrapper">
          <div className="eddp-header-section">
            <div className="eddp-dog-icon-container">
              <img
                src={progressIcon}
                alt="Progress Step"
                className="eddp-progress-icon"
              />
            </div>
            <div className="eddp-progress-track">
              <div className="eddp-progress-fill eddp-step-1-fill"></div>
            </div>
          </div>

          <div className="eddp-form-group">
            <label className="eddp-label">WHAT IS YOUR DOG'S NAME?</label>
            <input
              type="text"
              name="dogName"
              placeholder="Enter here"
              value={formData.dogName}
              onChange={handleChange}
              className={`eddp-text-input ${formData.dogName ? "has-value" : ""}`}
            />
          </div>

          <div className="eddp-form-group eddp-dropdown-wrapper">
            <label className="eddp-label">
              WHAT BREED IS{" "}
              {formData.dogName ? formData.dogName.toUpperCase() : "[DOG NAME]"}
              ?
            </label>
            <p className="eddp-sub-label">
              Start typing and choose from pre-populated drop-down breeds
            </p>

            <div
              className={`eddp-dropdown-trigger ${isMainBreedDropdownOpen ? "open" : ""} ${formData.dogBreed ? "has-value" : ""}`}
              onClick={() => setIsMainBreedDropdownOpen(true)}
            >
              <input
                style={searchInputStyle}
                placeholder={formData.dogBreed || "Type or choose breed"}
                value={mainSearch}
                onChange={(e) => setMainSearch(e.target.value)}
              />
              {isMainBreedDropdownOpen ? (
                <ChevronUp size={20} />
              ) : (
                <ChevronDown size={20} />
              )}
            </div>

            {isMainBreedDropdownOpen && (
              <div className="eddp-dropdown-menu">
                {filteredMainBreeds.map((breed, index) => (
                  <div
                    key={index}
                    className="eddp-dropdown-option"
                    onClick={() => handleMainBreedSelect(breed)}
                  >
                    {breed}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="eddp-form-group">
            <p className="eddp-helper-text">
              If {formData.dogName || "[dog name]"} is a mix of breeds, simply
              choose “Mixed breed” above! After that choose their additional
              breeds here. Up to 3 breeds can be chosen.
            </p>

            {["selectedBreed1", "selectedBreed2", "selectedBreed3"].map(
              (field, idx) => (
                <div key={field} className="eddp-dropdown-wrapper mb-2">
                  <div
                    className={`eddp-dropdown-trigger ${openDropdown === field ? "open" : ""} ${formData[field] ? "has-value" : ""}`}
                    style={!isMixedBreed ? inactiveStyle : undefined}
                    onClick={() => isMixedBreed && setOpenDropdown(field)}
                  >
                    <input
                      style={searchInputStyle}
                      disabled={!isMixedBreed}
                      placeholder={formData[field] || `Select breed ${idx + 1}`}
                      value={subSearches[field] || formData[field]}
                      onChange={(e) =>
                        setSubSearches({
                          ...subSearches,
                          [field]: e.target.value,
                        })
                      }
                    />
                    {openDropdown === field ? (
                      <ChevronUp size={20} />
                    ) : (
                      <ChevronDown size={20} />
                    )}
                  </div>

                  {isMixedBreed && openDropdown === field && (
                    <div className="eddp-dropdown-menu">
                      {getFilteredSubBreeds(field).map((breed, i) => (
                        <div
                          key={i}
                          className="eddp-dropdown-option"
                          onClick={() => handleBreedSelect(field, breed)}
                        >
                          {breed}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ),
            )}
          </div>

          <div className="eddp-form-group">
            <label className="eddp-label">
              SELECT{" "}
              {formData.dogName
                ? formData.dogName.toUpperCase() + "'S"
                : "[DOG NAME]'S"}{" "}
              GENDER
            </label>
            <div className="eddp-gender-buttons">{renderGenderButtons()}</div>
          </div>

          {/* Mobile Only Step 1 Footer */}
          {/* <div className="eddp-next-area eddp-mobile-only eddp-step-1-next">
            <button
              type="button"
              className="eddp-exit-btn"
              onClick={() => navigate("/user-profile")}
              style={{ color: window.innerWidth <= 768 ? "#009fd9" : "" }}
            >
              EXIT
            </button>
            <div
              className={`eddp-next-wrapper ${isStep1Valid ? "enabled" : "disabled"}`}
              onClick={() => isStep1Valid && setMobileStep(2)}
            >
              <button className="eddp-next-btn">
                <span className="eddp-next-text" style={{ color: "#009fd9" }}>
                  NEXT
                </span>
                <div
                  className="eddp-next-icon-circle"
                  style={{ backgroundColor: "rgba(0, 159, 217, 0.15)" }}
                >
                  <img src={nextIcon2} alt="Next" className="eddp-next-img" />
                </div>
              </button>
            </div>
          </div> */}
          <MobileBottomBar
            onNext={() => isStep1Valid && setMobileStep(2)}
            isNextEnabled={isStep1Valid}
            nextIconSrc={nextIcon2}
            showSkip={true}
            skipText="EXIT"
            isSkipBlue={true}
            onSkip={() => navigate("/user-profile")}
            variant="blue"
          />
        </div>
      </div>

      {/* RIGHT PANEL (Mobile Step 2) */}
      <div
        className={`eddp-panel eddp-right-panel ${mobileStep === 2 ? "eddp-mobile-active" : "eddp-mobile-hidden"}`}
      >
        {/* Mobile Top Header */}
        {/* <div className="eddp-mobile-header eddp-mobile-only">
          <button
            className="eddp-login-back-btn eddp-mobile-back-override"
            onClick={() => setMobileStep(1)}
          >
            <ArrowLeft size={22} color="#fff" strokeWidth={3} />
            <span style={{ color: "#fff" }}>Back</span>
          </button>
          <div className="eddp-header-logo" style={{ color: "#fff" }}>
            <img src={appIcon} alt="Social Paws" className="eddp-logo-img" />
            <span>Social Paws</span>
          </div>
        </div> */}
        <MobileTopBar
          onBack={() => setMobileStep(1)}
          backColor="#fff"
          logoColor="#fff"
        />

        <div className="eddp-content-wrapper">
          {/* Mobile Progress Bar */}
          <div className="eddp-header-section eddp-mobile-only">
            <div className="eddp-dog-icon-container">
              <img
                src={progressIcon}
                alt="Progress Step"
                className="eddp-progress-icon"
              />
            </div>
            <div className="eddp-progress-track">
              <div className="eddp-progress-fill eddp-step-2-fill"></div>
            </div>
          </div>

          {/* SECTION 1: BIRTHDAY */}
          <div
            className="eddp-selection-row"
            style={activeSection === "ageGroup" ? inactiveStyle : activeStyle}
            onClick={() =>
              activeSection === "ageGroup" && setActiveSection("birthday")
            }
          >
            <div className="eddp-content-column" style={{ width: "100%" }}>
              <h2 className="eddp-section-title">BIRTHDAY</h2>
              <div className="eddp-birthday-card">
                <style>{`.wheel-highlight-black { color: #000000 !important; font-weight: 700 !important; }`}</style>
                <WheelPickerWrapper>
                  <WheelPicker
                    options={monthOptions}
                    value={bMonth}
                    onValueChange={setBMonth}
                    optionItemHeight={30}
                    classNames={{ highlightItem: "wheel-highlight-black" }}
                  />
                  <WheelPicker
                    options={dayOptions}
                    value={bDay}
                    onValueChange={setBDay}
                    optionItemHeight={30}
                    classNames={{ highlightItem: "wheel-highlight-black" }}
                  />
                  <WheelPicker
                    options={yearOptions}
                    value={bYear}
                    onValueChange={setBYear}
                    optionItemHeight={30}
                    classNames={{ highlightItem: "wheel-highlight-black" }}
                  />
                </WheelPickerWrapper>
              </div>
              {activeSection === "birthday" && (
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "1rem",
                    marginBottom: "-1rem",
                  }}
                >
                  <h3
                    style={{
                      color: "#47D7AC",
                      fontSize: "18px",
                      fontWeight: "700",
                    }}
                  >
                    {ageText}
                  </h3>
                </div>
              )}
            </div>
          </div>

          <div className="eddp-divider-horizontal">
            <span>OR</span>
          </div>

          {/* SECTION 2: AGE GROUP */}
          <div
            className="eddp-selection-row"
            style={activeSection === "birthday" ? inactiveStyle : activeStyle}
          >
            <div className="eddp-content-column" style={{ width: "100%" }}>
              <h2 className="eddp-section-title">AGE GROUP</h2>
              <div className="eddp-age-group-list">
                {[
                  { label: "PUPPY", sub: "UP TO 1 YEAR" },
                  { label: "YOUNG DOG / ADOLESCENT", sub: "1 TO 2 YEARS" },
                  { label: "ADULT DOG", sub: "2 TO 7 YEARS" },
                  { label: "SENIOR DOG", sub: "7+ YEARS" },
                ].map((item, index) => (
                  <button
                    key={index}
                    className={`eddp-age-btn ${formData.dogAgeGroup === item.label ? "active" : ""}`}
                    onClick={() => handleAgeGroupSelect(item.label)}
                  >
                    <div className="eddp-btn-content">
                      {formData.dogAgeGroup === item.label && (
                        <Check
                          size={20}
                          strokeWidth={3}
                          className="eddp-check-icon"
                        />
                      )}
                      <div className="eddp-text-col">
                        <strong>{item.label}</strong>
                        <small>{item.sub}</small>
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* NEXT BUTTON (Desktop uses flex-end, Mobile uses bottom absolute/fixed) */}
          <div className="eddp-next-area eddp-step-2-next desktop-only">
            <button
              type="button"
              className="eddp-exit-btn"
              onClick={() => navigate("/user-profile")}
            >
              EXIT
            </button>

            <div
              className={`eddp-next-wrapper ${
                window.innerWidth >= 1024
                  ? isNextEnabled && !isUpdating
                    ? "enabled"
                    : "disabled"
                  : isStep2Valid && !isUpdating
                    ? "enabled"
                    : "disabled"
              }`}
              onClick={handleNext}
            >
              <button className="eddp-next-btn" disabled={isUpdating}>
                <span
                  className="eddp-next-text"
                  style={window.innerWidth < 1024 ? { color: "#47d7ac" } : {}}
                >
                  {isUpdating ? "Updating..." : "NEXT"}
                </span>
                <div
                  className="eddp-next-icon-circle"
                  style={
                    window.innerWidth < 1024
                      ? { backgroundColor: "rgba(71, 215, 172, 0.15)" }
                      : {}
                  }
                >
                  {isUpdating ? (
                    <Loader2 className="animate-spin" color="white" />
                  ) : (
                    <img src={nextIcon} alt="Next" className="eddp-next-img" />
                  )}
                </div>
              </button>
            </div>
          </div>
          <MobileBottomBar
            onNext={handleNext}
            isNextEnabled={isStep2Valid && !isUpdating}
            nextIconSrc={nextIcon}
            showSkip={true}
            skipText="EXIT"
            onSkip={() => navigate("/user-profile")}
            variant="green"
          />
        </div>
      </div>
    </div>
  );
};

export default DogDetailsEditPage;
